import { createAction, props } from '@ngrx/store';
import { EProductTemplatesListItem } from '@api-ui-app/src/app/e-commerce-product-templates/types/e-product-templates-list-item';
import { EProductTemplatesSearchParams } from '@api-ui-app/src/app/e-commerce-product-templates/types/e-product-templates-search-params';
import { EProductWithVariants } from '@gelato-api-ui/core/e-commerce/e-product-with-variants';
import { EStore } from '@gelato-api-ui/core/e-commerce/e-store';
import { EProductTemplatesSearchSortingParams } from '@api-ui-app/src/app/e-commerce-product-templates/types/e-product-templates-search-sorting-params';
import { EProductTemplateUsageEventStep } from '@api-ui-app/src/app/e-commerce-product-templates/types/e-product-template-usage-event-step.enum';

export const load = createAction(
  '[ECommerceProductTemplates] Load',
  props<{
    searchParams: EProductTemplatesSearchParams;
    offset: number;
  }>(),
);

export const loadSuccess = createAction(
  '[ECommerceProductTemplates] Load Success',
  props<{
    searchParams: EProductTemplatesSearchParams;
    items: EProductTemplatesListItem[];
    offset: number;
  }>(),
);

export const loadStart = createAction('[ECommerceProductTemplates] Load Start');

export const loadMore = createAction('[ECommerceProductTemplates] Load More');

export const refresh = createAction('[ECommerceProductTemplates] Refresh');

export const setSearchParams = createAction(
  '[ECommerceProductTemplates] Set Search Params',
  props<{ payload: EProductTemplatesSearchParams }>(),
);

export const setTemplateName = createAction(
  '[ECommerceProductTemplates] Set Template Name',
  props<{ payload: string }>(),
);

export const setSortingParams = createAction(
  '[ECommerceProductTemplates] Set Sorting Params',
  props<{ payload: EProductTemplatesSearchSortingParams }>(),
);

export const deleteProductTemplate = createAction(
  '[ECommerceProductTemplates] Delete Product Template',
  props<{ id: string }>(),
);

export const deleteProductTemplateSuccess = createAction('[ECommerceProductTemplates] Delete Product Template Success');

export const deleteProductTemplateFailure = createAction('[ECommerceProductTemplates] Delete Product Template Failure');

export const duplicateProductTemplate = createAction(
  '[ECommerceProductTemplates] Duplicate Product Template',
  props<{ id: string; templateName: string }>(),
);

export const duplicateProductTemplateSuccess = createAction(
  '[ECommerceProductTemplates] Duplicate Product Template Success',
);

export const duplicateProductTemplateFailure = createAction(
  '[ECommerceProductTemplates] Duplicate Product Template Failure',
);

export const renameProductTemplate = createAction(
  '[ECommerceProductTemplates] Rename Product Template',
  props<{ id: string; templateName: string }>(),
);

export const renameProductTemplateSuccess = createAction('[ECommerceProductTemplates] Rename Product Template Success');

export const renameProductTemplateFailure = createAction('[ECommerceProductTemplates] Rename Product Template Failure');

export const addProductTemplateToStore = createAction(
  '[ECommerceProductTemplates] Add Product Template To Store',
  props<{ storeId: string; productTemplateId: string }>(),
);

export const addProductTemplateToStoreSuccess = createAction(
  '[ECommerceProductTemplates] Add Product Template To Store Success',
  props<{ payload: EProductWithVariants }>(),
);

export const addProductTemplateToStoreFailure = createAction(
  '[ECommerceProductTemplates] Add Product Template To Store Failure',
);

export const createProductTemplate = createAction('[ECommerceProductTemplates] Create Product Template');

export const createProductTemplateSuccess = createAction(
  '[ECommerceProductTemplates] Create Product Template Success',
  props<{ store: EStore }>(),
);

export const createProductTemplateFailure = createAction(
  '[ECommerceProductTemplates] Create Product Template  Failure',
);

export const editProductTemplate = createAction(
  '[ECommerceProductTemplates] Edit Product Template',
  props<{ id: string }>(),
);

export const editProductTemplateSuccess = createAction(
  '[ECommerceProductTemplates] Edit Product Template Success',
  props<{ store: EStore; id: string }>(),
);

export const editProductTemplateFailure = createAction('[ECommerceProductTemplates] Edit Product Template Failure');

export const logProductTemplateUsageInitiatedEvent = createAction(
  '[ECommerceProductTemplates] Log Product Template Usage Initiated Event',
  props<{ step: EProductTemplateUsageEventStep }>(),
);

export const setLoadingState = createAction(
  '[ECommerceProductTemplates] Set loadig state',
  props<{ isLoading: boolean }>(),
);

export const logProductTemplateUsageCompletedEvent = createAction(
  '[ECommerceProductTemplates] Log Product Template Usage Completed Event',
);
